import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useCallback, useState } from "react"
import { useUnbanV1CmMutation } from "../../core/api/clockmaker-social-api"

const CmUnbanControl = ({ disabled, userId }) => {
    const [open, setOpen] = useState(false)
    const [reason, setReason] = useState("")

    const [unban, { isLoading }] = useUnbanV1CmMutation()

    const handleOpenDialog = useCallback(() => {
        setOpen(true)
    }, [setOpen])

    const handleCloseDialog = useCallback(() => {
        setOpen(false)
        setReason("")
    }, [setOpen, setReason])

    const handleChangeReason = useCallback((e) => {
        setReason(e?.target?.value ?? "")
    }, [setReason])

    const handleConfirm = useCallback(() => {
        unban({
            userId: userId,
            reason: reason.trim()
        })
        handleCloseDialog()
    }, [userId, reason, unban, handleCloseDialog])

    return (
        <>
            <Button
                fullWidth
                loading={isLoading}
                size="small"
                disabled={disabled}
                onClick={handleOpenDialog}
                color="error"

                variant={"outlined"}
            >
                Unban on server
            </Button>
            <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCloseDialog}>
                <DialogTitle>
                    Unban player '{userId}'
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        rows={2}
                        margin="dense"
                        label="Reason"
                        value={reason}
                        onChange={handleChangeReason}
                    />
                </DialogContent>
                <DialogActions sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                    <Button variant="contained" disabled={reason.trim() === ""} onClick={handleConfirm}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={handleCloseDialog}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CmUnbanControl
